<template>
    <div class="overview-div">
        <div class="overview-header">Incident Overview</div>
        <div class="overview-content">
            A security breach has been identified affecting our systems due to an unpatched vulnerability in a third-party
            software component. The attack resulted in unauthorized access to sensitive customer data, including:
            <br />
            <br />
            <div class="icon-div">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Personally Identifiable Information (PII)</span>: Names, email addresses
                </div>
            </div>
            <div class="icon-div">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Credential Data</span>: Hashed passwords (bcrypt, work factor 12)
                </div>
            </div>
            <br />
            The breach was detected during routine security monitoring, where unusual API traffic patterns and unauthorized
            database queries triggered automated alerts. Our investigation revealed that the attackers exploited a zero-day
            vulnerability in the third-party library used for authentication services.
        </div>
    </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.overview-div {
    @apply flex flex-col items-start gap-2;
}
.overview-header {
    @apply text-zinc-700 font-inter text-base font-semibold leading-6;
}
.overview-content {
    @apply text-zinc-950 font-inter text-sm font-normal leading-6;

    span {
        @apply text-zinc-950 font-inter text-sm font-semibold leading-6;
    }

    .icon-div {
        @apply flex flex-row items-center ml-2;
    }
}
</style>
